<script setup lang="ts">
/**
 * Affichage des toasts « en direct » (quelqu'un vient de donner, réserver…),
 * EN BAS À GAUCHE (Karim 2026-10-13) — les autres messages du site restent
 * en bas à droite (toaster Nuxt UI). Sur téléphone, sous le header : le bas
 * de l'écran porte déjà la barre de don et le chat.
 *
 * Alimenté par `useToastEnDirect` (état partagé `toasts-en-direct`).
 */
import ToastEnDirectContenu from "~/components/shared/ToastEnDirectContenu.vue";
import { useToastsEnDirectListe } from "~/composables/useToastEnDirect";

const liste = useToastsEnDirectListe();
</script>

<template>
  <div
    class="pointer-events-none fixed z-[70] flex flex-col gap-2 left-3 right-3 top-[calc(env(safe-area-inset-top)+84px)] sm:right-auto sm:top-auto sm:left-6 sm:bottom-6"
    aria-live="polite"
  >
    <TransitionGroup
      enter-active-class="transition-[translate,opacity,scale] duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
      enter-from-class="opacity-0 -translate-y-3 sm:translate-y-0 sm:-translate-x-6 scale-95"
      leave-active-class="transition-[translate,opacity] duration-300 ease-in"
      leave-to-class="opacity-0 -translate-y-3 sm:translate-y-0 sm:-translate-x-6"
      move-class="transition-[translate] duration-300"
    >
      <div
        v-for="t in liste"
        :key="t.id"
        class="pointer-events-auto w-fit max-w-full rounded-[22px] bg-white py-3 pl-3.5 pr-5 shadow-[0_12px_40px_-8px_rgba(12,48,151,0.35),0_2px_8px_rgba(0,0,0,0.06)] ring-1 ring-black/[0.06]"
      >
        <ToastEnDirectContenu :titre="t.titre" :quand="t.quand" />
      </div>
    </TransitionGroup>
  </div>
</template>
